import { iUserAppPermission } from "@sdk/user-management/user-management.models";
import find from "lodash/find";
import flattenDeep from "lodash/flattenDeep";
import isEqual from "lodash/isEqual";
import sortBy from "lodash/sortBy";

export enum Apps {
  TEXTS = "TEXTS",
  ORGANIZATION_MANAGEMENT = "ORGANIZATION_MANAGEMENT",
  CRM = "CRM",
  CONVERSATION = "CONVERSATION",
  HELP_DESK = "HELP_DESK",
  REPORTS = "REPORTS",
  TA_DESK = "TA_DESK",
}

export enum HelpDeskScopes {
  CREATE_INBOXES = "CREATE_INBOXES",
  MANAGE_INBOXES = "MANAGE_INBOXES",
}
export enum ReportScopes {
  VIEW_REPORT = "VIEW_REPORT",
}

export enum OrganizationManagementScopes {
  ADMIN_ACCOUNT = "ADMIN_ACCOUNT",
}

export enum CRMScopes {
  MANAGE_CONTACTS = "MANAGE_CONTACTS",
  MANAGE_AUTOMATIONS = "MANAGE_AUTOMATIONS",
}

export enum ConversationScopes {
  CHAT = "CHAT",
}

export enum TaDeskScopes {
  MANAGE_QUOTES = "MANAGE_QUOTES",
  MANAGE_TEAM_QUOTES = "MANAGE_TEAM_QUOTES",
  MANAGE_BOOKINGS = "MANAGE_BOOKINGS",
  MANAGE_TEAM_BOOKINGS = "MANAGE_TEAM_BOOKINGS",
  BOOKING_ADMIN = "BOOKING_ADMIN",
}


/** @deprecated Legacy role presets — use ROLE_TEMPLATES in @sdk/access/access-role-templates */
export const Roles: {
  label: string;
  permissions: iUserAppPermission[];
}[] = [
    {
      label: "Owner",
      permissions: [
        {
          appId: Apps.ORGANIZATION_MANAGEMENT,
          scopes: [
            {
              scope: OrganizationManagementScopes.ADMIN_ACCOUNT,
              data: {},
            },
          ],
        },
        {
          appId: Apps.TA_DESK,
          scopes: [
            {
              scope: TaDeskScopes.MANAGE_BOOKINGS,
              data: {},
            },
            {
              scope: TaDeskScopes.MANAGE_TEAM_BOOKINGS,
              data: {},
            },
            {
              scope: TaDeskScopes.MANAGE_TEAM_QUOTES,
              data: {},
            },
            {
              scope: TaDeskScopes.BOOKING_ADMIN,
              data: {},
            },
          ],
        },
      ],
    },
    {
      label: "Manager",
      permissions: [
        {
          appId: Apps.TA_DESK,
          scopes: [
            {
              scope: TaDeskScopes.MANAGE_BOOKINGS,
              data: {},
            },
            {
              scope: TaDeskScopes.MANAGE_TEAM_BOOKINGS,
              data: {},
            },
            {
              scope: TaDeskScopes.MANAGE_TEAM_QUOTES,
              data: {},
            },
          ],
        },
      ],
    },
    {
      label: "Travel Agent",
      permissions: [
        {
          appId: Apps.ORGANIZATION_MANAGEMENT,
          scopes: [
            {
              scope: OrganizationManagementScopes.ADMIN_ACCOUNT,
              data: {},
            },
          ],
        },
        {
          appId: Apps.TA_DESK,
          scopes: [
            {
              scope: TaDeskScopes.MANAGE_QUOTES,
              data: {},
            },
            {
              scope: TaDeskScopes.MANAGE_BOOKINGS,
              data: {},
            },
          ],
        },
      ],
    },
    // TA Desk Roles
    {
      label: "Booking Admin",
      permissions: [
        {
          appId: Apps.ORGANIZATION_MANAGEMENT,
          scopes: [
            {
              scope: OrganizationManagementScopes.ADMIN_ACCOUNT,
              data: {},
            },
          ],
        },
        {
          appId: Apps.TA_DESK,
          scopes: [
            {
              scope: TaDeskScopes.BOOKING_ADMIN,
              data: {},
            },
          ],
        },
      ],
    },
  ];

/** @deprecated Use summarizeUserAccess from @sdk/access/access-role-templates */
export const getRoleFromPermission = (permissions: iUserAppPermission[]) => {
  const currentScopes = flattenDeep(
    permissions.map((permission) =>
      permission.scopes.map((scope) => ({
        app: permission.appId,
        scope: scope.scope,
      }))
    )
  ).map((scope) => `${scope.app}:${scope.scope}`);
  for (const role of Roles) {
    const requiredScopesForRole = flattenDeep(
      role.permissions.map((permission) =>
        permission.scopes.map((scope) => ({
          app: permission.appId,
          scope: scope.scope,
        }))
      )
    ).map((scope) => `${scope.app}:${scope.scope}`);
    if (isEqual(sortBy(requiredScopesForRole), sortBy(currentScopes))) {
      return role.label;
    }
  }
  if (currentScopes.length > 0) {
    return "CUSTOM";
  }
  return "N/A";
};

/** @deprecated Use buildUserAccessFromRoles from @sdk/access/access.models */
export const getPermissionFromRole = (role: string) => {
  return find(Roles, { label: role })?.permissions;
};
